<template>
  <input
    :type="type"
    :value="modelValue"
    :state="state"
    :placeholder="placeholder"
    :trim="trim"
    class="vf-a-input"
    :class="`vf-a-input--${type} ${getClass}`"
    :autocomplete="autocomplete"
    :aria-label="computedAriaLabel"
    @input="handleInput"
    @change="handleChange"
    @keypress="handleKeypress"
  />
</template>
<script lang="ts" setup>
import { computed, PropType } from "vue";

const props = defineProps({
  size: {
    type: String,
    default: "md",
  },
  type: {
    type: String,
    default: "text",
  },
  placeholder: {
    type: String,
    default: "",
  },
  // Accessible name. Falls back to the placeholder so every input
  // always has a programmatic label (WCAG 4.1.2 / Lighthouse).
  label: {
    type: String,
    default: "",
  },
  // Valid autocomplete token ("email", "given-name", "off", ...).
  autocomplete: {
    type: String,
    default: "off",
  },
  state: {
    type: Boolean,
    default: null,
  },
  trim: {
    type: Boolean,
    default() {
      return false;
    },
  },
  modelValue: {
    type: [String, Number, Object] as PropType<string | number | object>,
    default() {
      return null;
    },
  },
});
const computedAriaLabel = computed(
  () => props.label || props.placeholder || undefined
);
const getClass = computed(() => {
  const result: string[] = [];

  if (props.size === "sm") {
    result.push("--sm");
  }

  if (props.size === "md") {
    result.push("--md");
  }

  if (props.size === "lg") {
    result.push("--lg");
  }

  if (!(props.state || props.state === null)) {
    result.push("--error");
  }

  return result.join(" ");
});
const emit = defineEmits(["update:modelValue", "change", "keypress"]);
const handleInput = (e: any) => {
  emit("update:modelValue", e.target.value);
};
const handleChange = (e: any) => {
  emit("change", e.target.value);
};
const handleKeypress = (e: any) => {
  emit("keypress", e);
};
</script>
